module.exports = __webpack_public_path__ + "static/media/capitalsphere_sp3.e9f3c3bf.svg";